<div
  class="atl-custom-checkbox {{ sizeInput }}"
  [class.disabled]="disabledState"
  (mousedown)="$event.stopImmediatePropagation()"
>
  <input type="checkbox" [checked]="checked" [id]="uniqID" hidden (click)="toggle($event)" />
  <label [for]="uniqID" [attr.data-cy]="uniqID"></label>
  <span class="atl-custom-checkbox__text" *ngIf="text"> {{ text | translate }}</span>
</div>
